"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWrongAnswers = void 0;
exports.transformWrongQuestionIds = transformWrongQuestionIds;
var _arrays = require("./arrays");
var getWrongAnswers = exports.getWrongAnswers = function getWrongAnswers(questions, chapterAnswers) {
  var validatableQuestions = questions.filter(function (x) {
    return x.content && ['mc', 'sc'].includes(x.questionType);
  });
  if (validatableQuestions.length === 0) {
    return [];
  }
  var wrongQuestionIds = validateAnswers(validatableQuestions, chapterAnswers);
  return wrongQuestionIds;
};
function validateAnswers(validatableQuestions, chapterAnswers) {
  var wrongQuestionIds = [];
  validatableQuestions.forEach(function (question) {
    var answer = chapterAnswers[question.id];
    if (question.questionType === 'mc' && !validateMultipleChoice(question, answer)) {
      wrongQuestionIds.push(question.id);
    }
    if (question.questionType === 'sc' && !validateSingleChoice(question, answer)) {
      wrongQuestionIds.push(question.id);
    }
  });
  return wrongQuestionIds;
}
function validateMultipleChoice(question, answer) {
  if (question.content.some(function (x) {
    return [true, false].includes(x.correct);
  })) {
    var selectedIndices = answer && answer.antwort && answer.antwort.selectedIndices ? answer.antwort.selectedIndices.sort() : [];
    var correctIndices = question.content.filter(function (i) {
      return i.correct;
    }).map(function (i) {
      return i.order;
    }).sort();
    return (0, _arrays.areEqual)(selectedIndices, correctIndices);
  }
  return true;
}
function validateSingleChoice(question, answer) {
  var correctAnswer = question.content.find(function (i) {
    return i.correct;
  });
  if (correctAnswer && answer && answer.antwort) {
    var correctIndex = correctAnswer.order;
    var selectedIndex = answer.antwort.selectedIndex;
    return correctIndex === selectedIndex;
  }
  return true;
}
function transformWrongQuestionIds() {
  var questions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var wrongAnswerIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return questions.filter(function (x) {
    return wrongAnswerIds.includes(x.id);
  }).map(function (x) {
    return x.order;
  }).join(', ');
}